import React from 'react';
import { useState, useEffect } from 'react';
import Fade from 'react-reveal/Fade';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import ReactMarkdown from 'react-markdown';

import 'react-lazy-load-image-component/src/effects/blur.css';

// import { ReactComponent as Logo } from '../../assets/undraw_code_review_l1q9.svg';

import {
	AboutPageContainer,
	JumbotronContainer,
	JumbotronLeftItem,
	JumbotronRightItem,
	JumbotronHeading,
	JumbotronParagraph,
	ResumeLinkButtonContainer,
	ResumeLinkButton
} from './about.styles';

import Spinner from '../../components/spinner/spinner.component';

const query = `
{
  aboutCollection {
  items {
      aboutHeading
      aboutParagraph
      jumbotronImage {
        title
        url
      }
      resumeUrl
    }
  }
}
`;

function AboutPage() {
	const [about, setAbout] = useState(null);

	useEffect(() => {
		window
			.fetch(
				`https://graphql.contentful.com/content/v1/spaces/ym6e4amg96px/`,
				{
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						// Authenticate the request
						Authorization:
							'Bearer kKdDkh_S-vYInDybOrb1OCD5WvJ3vQVnVA-4tcicXpo'
					},
					// send the GraphQL query
					body: JSON.stringify({ query })
				}
			)
			.then((response) => response.json())
			.then(({ data, errors }) => {
				if (errors) {
					console.error(errors);
				}

				// rerender the entire component with new data
				setAbout(data.aboutCollection.items[0]);
			});
	}, []);

	if (!about) {
		return <Spinner />;
	}

	return (
		<AboutPageContainer>
			<Fade top cascade>
				<JumbotronHeading>{about.aboutHeading}</JumbotronHeading>
			</Fade>
			<JumbotronContainer>
				<JumbotronLeftItem>
					<Fade left cascade>
						<JumbotronParagraph>
							<ReactMarkdown>{about.aboutParagraph}</ReactMarkdown>
						</JumbotronParagraph>
					</Fade>
				</JumbotronLeftItem>
				<Fade left cascade>
					<JumbotronRightItem>
						<LazyLoadImage
							src={about.jumbotronImage.url}
							alt={about.jumbotronImage.title}
							style={{
								width: '100%',
								height: '100%',
								// objectFit: 'cover',
								maxWidth: '300px',
								borderRadius: '100%'
							}}
						/>
					</JumbotronRightItem>
				</Fade>
			</JumbotronContainer>
			<Fade bottom cascade>
				<ResumeLinkButtonContainer>
					<a href={about.resumeUrl} target='blank'>
						<ResumeLinkButton>LinkedIn Profile</ResumeLinkButton>
					</a>
				</ResumeLinkButtonContainer>
			</Fade>
		</AboutPageContainer>
	);
}

export default AboutPage;
